































import { Vue, Component, Prop } from 'vue-property-decorator';
import KeywordWithResultList from '@/components/common/input/KeywordWithResultList.vue';
import { KeywordData } from '@/types';
import ClickOutside from 'vue-click-outside';
@Component({
  directives: {
    ClickOutside,
  },
  components: { KeywordWithResultList },
})
export default class FormAutoComplete extends Vue {
  @Prop({ required: true })
  private readonly data: KeywordData[];
  
  @Prop({ required: true })
  private readonly title: string;
  
  @Prop({ default: 'COMMON_INSERT' })
  private readonly placeholder: string;
  
  private keyword = '';
  private resultList: KeywordData[] = [];
  
  public reset() {
    this.resetResultList();
    this.setKeyword();
  }
  
  private handleInput({ target }) {
    const keyword = target.value.trim();
    keyword ? this.search(keyword) : this.resetResultList();
    this.setKeyword(keyword);
  }
  
  private selectedNoHandler(selectedNo?: number) {
    const found: KeywordData = this.data.find(({ no }) => no === selectedNo);
    const label = found?.label;
    this.setKeyword(label);
    this.$emit('selected-keyword', selectedNo || null);
    this.resetResultList();
  }
  
  private search(keyword: string) {
    this.resultList = this.data.filter(({ label }) => label.includes(keyword)).map(({ no, label }) => ({ no, label: label.replaceAll(keyword, `<span class="blue">${keyword}</span>`) }))
  }
  
  private setKeyword(label?: string) {
    this.keyword = label ?? '';
  }
  
  private resetResultList() {
    this.resultList = [];
  }
  
  private handleClickOutside() {
    const found: KeywordData = this.data.find(({ label }) => label === this.keyword);
    this.selectedNoHandler(found?.no);
  }
}
